import type { SVGProps } from 'react';
const SvgExpandLess = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#expand_less_svg__a)">
      <path
        fill="currentColor"
        d="m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6Z"
      />
    </g>
    <defs>
      <clipPath id="expand_less_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgExpandLess;
